import { render, staticRenderFns } from "./ClinicEditBankDetails.vue?vue&type=template&id=03794f84&"
import script from "./ClinicEditBankDetails.vue?vue&type=script&lang=js&"
export * from "./ClinicEditBankDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports